import React, {FC, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {BrowserRouter, Switch} from 'react-router-dom';

import 'plyr/dist/plyr.css'
import './App.scss';
import './App.css';


import Header from './components/sections/Header';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import ForgotPassword from './pages/ForgotPassword';
import Homepage from './pages/Homepage';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/routes/PrivateRoute';
import PublicRoute from './components/routes/PublicRoute';
import Loader from './components/UI/Loader';
import firebase from './config/firebase';
import {anonymousLogin, getUserById, setLoading, setNeedVerification, setToken} from './store/actions/authActions';
import {RootState} from './store';

const App: FC = () => {
    const dispatch = useDispatch();
    const {loading} = useSelector((state: RootState) => state.auth);

    // Check if user exists
    useEffect(() => {
        dispatch(setLoading(true));
        const subscribe = firebase.auth().onAuthStateChanged(async (user: any) => {
            if (user) {
                console.log(user.uid);
                dispatch(setLoading(true));
                await dispatch(getUserById(user.uid));
                console.log("App:FC->User.uid:", user.uid);

                if (!user.emailVerified) {
                    dispatch(setNeedVerification());
                }
            } else {
                console.log("No Anon User Create OneN");
                dispatch(anonymousLogin());
            }
            dispatch(setLoading(false));

        });
  
        const refreshtoken = firebase.auth().onIdTokenChanged(async (user) => {
            console.log("refresh");
            if (user) {
                const newToken = (await user?.getIdToken())?.toString();
                dispatch(setToken(newToken));
            }
        });

        return () => {
            subscribe();
            refreshtoken();
        };
    }, [dispatch]);

    if (loading) {
        return <Loader/>;
    }

    return (
        <BrowserRouter>
            <Header/>
            <Switch>
                <PublicRoute path="/" component={Homepage} exact/>
                <PublicRoute path="/signup" component={SignUp} exact/>
                <PublicRoute path="/signin" component={SignIn} exact/>
                <PublicRoute path="/forgot-password" component={ForgotPassword} exact/>
                <PrivateRoute path="/dashboard" component={Dashboard} exact/>
            </Switch>
        </BrowserRouter>
    );
};

export default App;
